module.exports = __webpack_public_path__ + "static/media/letterL.68a9bca9.svg";